var _g, _circle, _rect, _rect2, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAutoCheckout(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 58,
    height: 58,
    viewBox: "0 0 58 58",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_753_13797)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M44.82 33C45.24 33 45.61 32.74 45.76 32.35L53.94 10.35C54.05 10.04 54.01 9.7 53.82 9.43C53.63 9.16 53.33 9 53 9H14.8L12.98 0.78C12.88 0.32 12.47 0 12 0H5C4.45 0 4 0.45 4 1C4 1.55 4.45 2 5 2H11.2L13.03 10.22C13.08 10.46 13.23 10.66 13.42 10.8L17.25 30.96C17.11 31.13 17.01 31.34 17.01 31.58V38.01C17.01 38.27 17.12 38.53 17.3 38.72C17.49 38.91 17.74 39.01 18.01 39.01H47.29C47.84 39.01 48.29 38.56 48.29 38.01C48.29 37.46 47.84 37.01 47.29 37.01H19V33.01H44.82V33ZM51.56 11L44.13 31H19.28L15.48 11H51.56Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21 40C18.24 40 16 42.24 16 45C16 47.76 18.24 50 21 50C23.76 50 26 47.76 26 45C26 42.24 23.76 40 21 40ZM21 48C19.34 48 18 46.66 18 45C18 43.34 19.34 42 21 42C22.66 42 24 43.34 24 45C24 46.66 22.66 48 21 48Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43 40C40.24 40 38 42.24 38 45C38 47.76 40.24 50 43 50C45.76 50 48 47.76 48 45C48 42.24 45.76 40 43 40ZM43 48C41.34 48 40 46.66 40 45C40 43.34 41.34 42 43 42C44.66 42 46 43.34 46 45C46 46.66 44.66 48 43 48Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22 16H45C45.55 16 46 15.55 46 15C46 14.45 45.55 14 45 14H22C21.45 14 21 14.45 21 15C21 15.55 21.45 16 22 16Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40 20H23C22.45 20 22 20.45 22 21C22 21.55 22.45 22 23 22H40C40.55 22 41 21.55 41 21C41 20.45 40.55 20 40 20Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35 26H24C23.45 26 23 26.45 23 27C23 27.55 23.45 28 24 28H35C35.55 28 36 27.55 36 27C36 26.45 35.55 26 35 26Z",
    fill: "black"
  }))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 47,
    cy: 47,
    r: 11,
    fill: "#25BB73"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 40.1152,
    y: 46.8223,
    width: 1.5,
    height: 7.58759,
    rx: 0.75,
    transform: "rotate(-45 40.1152 46.8223)",
    fill: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 45.48,
    y: 52.1875,
    width: 1.5,
    height: 11.9926,
    rx: 0.75,
    transform: "rotate(-135 45.48 52.1875)",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_753_13797"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 50,
    height: 50,
    fill: "white",
    transform: "translate(4)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAutoCheckout);
export default __webpack_public_path__ + "static/media/autoCheckout.9709f3a0cb3f66a41529d41d680b555a.svg";
export { ForwardRef as ReactComponent };